import { Module } from '@nestjs/common';
import { NotifyPartyController } from './notify-party.controller';
import { NotifyPartyService } from './notify-party.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { NotifyParty } from './notify-party.entity';
import { NotifyPartyAdapter } from './dto/notify-party.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports:[
    TypeOrmModule.forFeature([NotifyParty]),
  ],
  controllers: [NotifyPartyController],
  providers: [NotifyPartyService,ApplicationExceptionHandler,NotifyPartyAdapter,LogsService]
})
export class NotifyPartyModule {}